import {
  AttributionInsights,
  exampleAttributionInsight,
  DemographicAttributionRows,
} from './AttributionInsights';

export type FacebookGenderType = 'Male' | 'Female' | 'Uncategorized';

export interface DemographicAttributionInsights extends AttributionInsights {
  age: string; // '45-54'
  gender: FacebookGenderType; // 'Male' | 'Female' | 'Uncategorized'
}

export const exampleDemographicAttributionInsight: DemographicAttributionInsights = {
  ...exampleAttributionInsight,
  age: '45-54',
  gender: 'Male',
};

export const demographicAttributionBreakdown: DemographicAttributionRows = {
  rows: [exampleDemographicAttributionInsight],
  breakdownType: 'Demographic',
};
